var e="https://avitrucdn2.azureedge.net",t="knowledgepoint";export{e as BlobStorageBaseUrl,t as KnowledgepointSubPath};
